const activateBrowsePromotionsJs = '.activateBrowsePromotionsJs'
const searchResults = '#searchResults'
const prevPageContainer = '#prev-page-loader'
const loader = '#prevLoader'

import ItemBack from './itemBack'
export default class Paging {
  constructor() {
    this.isPromotions = $(activateBrowsePromotionsJs).length
    this.spService = this.isPromotions ? SP.browsePromotions : SP.searchresults
    this.hasItemToScroll = false
    const itemBeck = new ItemBack()
    itemBeck.onInit((hasScroll) => {
      this.hasItemToScroll = hasScroll
    })
    this.currentPage = 0
    this.prevPage = 0
    this.disable = false
    this.loading = false
    this.isFirstLoad = false
    this.infiniteScrollFn = this.onScroll.bind(this)
    $.subscribe('queryinit', () => {
      this.initScrollToPrev()
    })

    // after filter change remove everything
    $.subscribe('querychange', () => {
      this.onQueryChange()
      this.evaluateStateAfterPrevLoad()
    })
  }

  initScrollToPrev() {
    if (!$(prevPageContainer).length) {
      return
    }
    this.onQueryChange()

    setTimeout(() => {
      window.addEventListener('scroll', this.infiniteScrollFn, false)

      if (this.spService.itemScrolled) {
        return
      }
      if (this.hasItemToScroll) {
        return
      }
      this.isFirstLoad = true
      this.infiniteScrollFn()
    }, 2000)
  }

  onQueryChange() {
    this.currentPage = this.spService.query.page
    this.prevPage = this.spService.query.prevPageIndex
  }
  onScroll() {
    if (this.disable || this.loading) {
      return
    }
    const scroll = window.scrollY
    if (scroll < 1) {
      this.loadPrevPage()
    }
  }
  loadPrevPage() {
    if (this.loading) {
      return
    }
    this.loading = true
    // $(loader).slideDown()
    // window.disableAjaxLoader()
    this.initLottieTimeout()

    this.spService.getMoreResults(
      (result, isThereMore, paginationPosition, page) => {
        // window.enableAjaxLoader()
        // window.scrollTo(0, 0)
        setTimeout(
          () => {
            this.renderData(result, paginationPosition, page)
          },
          this.isFirstLoad ? 2000 : 0
        )
      },
      'prev'
    )
  }
  renderData(result, paginationPosition, page) {
    const html = result
      .map((item, index) => {
        let compiledTemplate
        if (item.promotionDetails || item.couponDetails) {
          compiledTemplate = Handlebars.getSharedTemplate('promotionBox')
        } else {
          compiledTemplate = Handlebars.getSharedTemplate('itemBox')
        }

        return compiledTemplate({
          item: item,
          position: index + 1 + paginationPosition,
          list: listNameForGA || SP.currentPageName,
          isMobile: true,
          page: page,
        })
      })
      .join('')

    const $html = $(html)
    itemBoxes.init($html)
    const prevScrollMarker = $('<div></div>')

    $(loader).hide('fast', () => {
      $(prevPageContainer).after(prevScrollMarker)
      $(prevPageContainer).after($html)
      $(document).scrollTop(prevScrollMarker.offset().top)
      prevScrollMarker.remove()

      this.loading = false

      itemBoxes.updateCartEntriesFromCache()
      // container.children().unwrap()
      $('#lottieLoader').removeClass('prev-loader-d-flex')
      this.evaluateStateAfterPrevLoad()
    })
  }

  evaluateStateAfterPrevLoad() {
    if (this.spService.query.page === 0) {
      this.removeListeners()
    }
  }
  initLottieTimeout () {
    $('#lottieLoader').addClass('time-d-flex')
    $('#lottieLoader').addClass('prev-loader-d-flex')
    setTimeout(function () {
      $('#lottieLoader').removeClass('time-d-flex')
    }, 1500)
  }
  removeListeners() {
    this.disable = true
    window.removeEventListener('scroll', this.infiniteScrollFn)
    $(prevPageContainer).remove()
  }
}

$(() => {
  if ($(searchResults).length) {
    new Paging()
  }
})
